import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthGuard } from './shared/auth.guard';

import { AuthTokenComponent } from './components/auth-token.component';
import { ClaimsComponent } from './components/claims.component';
import { PageNotFoundComponent } from './components/page-not-found.component';
import { PageAccessDeniedComponent } from './components/page-access-denied.component';

import { HomeComponent } from './components/home.component';
import { SearchLocationComponent } from './components/riskassessment/search-location/search-location.component';
import { LocationDetailsComponent } from './components/riskassessment/location-details/location-details.component';
import { SelectModelComponent } from './components/riskassessment/select-model/select-model.component';
import { SelectParametersComponent } from './components/riskassessment/select-parameters/select-parameters.component';
import { CalculationResultComponent } from './components/riskassessment/calculation-result/calculation-result.component';
import { ExternalLocationOverviewComponent } from './components/riskassessment/external-location-overview/external-location-overview.component';

import {
  CompoundDatailsComponent, PreliminaryCompoundDatailsComponent, PreliminaryScreeningLocationDetailsComponent,
  ScreeningLocationDetailsComponent, ScreeningSearchLocationComponent
} from './components/screening';

import { FindDraftComponent } from './components/draft-screening/find-draft/find-draft.component';
import { InitDraftComponent } from './components/draft-screening/init-draft/init-draft.component';
import { StatisticsIndexComponent } from './components/statistics/index.component';
import { PreliminaryLocationDetailsComponent } from './components/riskassessment/preliminary-location-details/preliminary-location-details.component';
import { RemovedPageComponent } from './components/removed-page/removed-page.component';
import { SearchCalculationComponent } from './components/riskassessment/search-calculation/search-calculation.component';

const routes: Routes = [
  // { path: '', redirectTo: '/home', pathMatch: 'full' },
  { path: '', component: HomeComponent },

  // Risk assessmint sub pages
  { path: 'riskassessment/search', canActivate: [AuthGuard], component: SearchLocationComponent },
  { path: 'riskassessment/location-details/:id', canActivate: [AuthGuard], component: LocationDetailsComponent },
  { path: 'riskassessment/select-model', canActivate: [AuthGuard], component: SelectModelComponent },
  { path: 'riskassessment/select-parameters', canActivate: [AuthGuard], component: SelectParametersComponent },
  { path: 'riskassessment/calculation-result/:id', canActivate: [AuthGuard], component: CalculationResultComponent },
  { path: 'riskassessment/external-location-overview', canActivate: [AuthGuard], component: ExternalLocationOverviewComponent },
  { path: 'riskassessment/preliminary/location-details/:id', canActivate: [AuthGuard], component: PreliminaryLocationDetailsComponent },

  { path: 'riskassessment/search-calculation', canActivate: [AuthGuard], component: SearchCalculationComponent },

  // Screening sub pages
  // { path: 'screening/search', canActivate: [AuthGuard], component: ScreeningSearchLocationComponent },
  // { path: 'screening/location-details/:id', canActivate: [AuthGuard], component: ScreeningLocationDetailsComponent },
  // { path: 'screening/compound-details/:id', canActivate: [AuthGuard], component: CompoundDatailsComponent },
  // { path: 'screening/preliminary/location-details/:id', canActivate: [AuthGuard], component: PreliminaryScreeningLocationDetailsComponent },
  // { path: 'screening/preliminary/compound-details/:id', canActivate: [AuthGuard], component: PreliminaryCompoundDatailsComponent },
  { path: 'screening/search', canActivate: [AuthGuard], component: RemovedPageComponent },
  { path: 'screening/location-details/:id', canActivate: [AuthGuard], component: RemovedPageComponent },
  { path: 'screening/compound-details/:id', canActivate: [AuthGuard], component: RemovedPageComponent },
  { path: 'screening/preliminary/location-details/:id', canActivate: [AuthGuard], component: RemovedPageComponent },
  { path: 'screening/preliminary/compound-details/:id', canActivate: [AuthGuard], component: RemovedPageComponent },

  // Draft screening sub pages
  { path: 'draft-screening/find-draft', canActivate: [AuthGuard], component: FindDraftComponent },
  { path: 'draft-screening/init-draft', canActivate: [AuthGuard], component: InitDraftComponent },

  // Statistics
  { path: 'statistics', canActivate: [AuthGuard], component: StatisticsIndexComponent },

  { path: 'callback', component: AuthTokenComponent },
  { path: 'claims', canActivate: [AuthGuard], component: ClaimsComponent },
  { path: 'access-denied', canActivate: [AuthGuard], component: PageAccessDeniedComponent },
  { path: '**', canActivate: [AuthGuard], component: PageNotFoundComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
